export default "__VITE_ASSET__4e6925a2__"